import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars";
import { getMovies } from "../../firebase/service";
import { HonkMovie } from "../../types/Movie";
import { User } from "../../types/User";
import Dropdown, { dropdownItem } from "../dropdown/dropdown";
import HonkMovieCard from "../movie/movie_card";
import NewHonkMovieModal from "../new-movie-modal/new_movie_modal";
import "./film_list.scss";
type FilmListProps = {
  currentUser: User;
};
const FilmList: React.FC<FilmListProps> = ({ currentUser }) => {
  const hideWatchedKey = "hide-watched";
  const hideWatchedByDefault = localStorage.getItem(hideWatchedKey);

  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [hideWatched, setHideWatched] = useState<boolean>(
    hideWatchedByDefault ? JSON.parse(hideWatchedByDefault) : false
  );
  const [movies, setHonkMovies] = useState<HonkMovie[]>([]);
  const [searchFilterInput, setSearchFilterInput] = useState<string>("");
  const [searchBy, setSearchBy] = useState<string>("title");

  useEffect(() => {
    getMovies((val) => {
      if (val) {
        const movieMap = Object.entries(val);
        const movies: HonkMovie[] = [];
        movieMap.forEach((movie: [string, HonkMovie]) => {
          const movieToAdd: HonkMovie = { ...movie[1] };
          movieToAdd.honk_id = movie[0];
          movies.push(movieToAdd);
        });
        setHonkMovies(movies);
      }
    });
  }, []);

  const onSetHideWatched = () => {
    setHideWatched(!hideWatched);
    localStorage.setItem(hideWatchedKey, JSON.stringify(!hideWatched));
  };

  const filterHonkMovie = (movie: HonkMovie, filterString: string): boolean => {
    const objectField = movie[searchBy as keyof typeof movie];
    if (objectField) {
      return objectField
        .toString()
        .toLowerCase()
        .includes(filterString.toLowerCase());
    } else return false;
  };

  const filterOptions: dropdownItem[] = [
    { label: "title", callback: () => setSearchBy("title") },
    { label: "genre", callback: () => setSearchBy("genre") },
    { label: "year", callback: () => setSearchBy("year") },
  ];

  let shownFilms = searchFilterInput
    ? movies.filter((movie) => filterHonkMovie(movie, searchFilterInput))
    : movies;

  if (hideWatched) {
    shownFilms = shownFilms.filter((movie) => !movie.watched);
  }

  const isMobile = window.innerWidth < 768;

  return (
    <div className={"film-list-wrapper"}>
      <div className={"top-bar"}>
        <div className={"search-bar"}>
          <input
            value={searchFilterInput}
            onChange={(e) => setSearchFilterInput(e.target.value)}
            className={"search-input"}
            type="search"
            placeholder="search..."
          />
          <Dropdown initiallySelected={0} options={filterOptions} />
        </div>
        <div className={"filter-section"}>
          <div className={"filter-text"}>Hide Watched</div>
          <input
            onChange={onSetHideWatched}
            type="checkbox"
            checked={hideWatched}
          />
        </div>
      </div>
      <Scrollbars style={isMobile ? { height: "55vh" } : { height: "75vh" }}>
        <div className={"film-list"}>
          {shownFilms.length > 0 ? (
            shownFilms.map((movie, index) => (
              <HonkMovieCard
                currentUser={currentUser}
                key={"movie-" + index}
                movie={movie}
              />
            ))
          ) : (
            <div className={"empty-text"}>There's nothing here...</div>
          )}
        </div>
      </Scrollbars>
      {showCreateModal ? (
        <NewHonkMovieModal
          closeModal={() => setShowCreateModal(false)}
          currentUser={currentUser}
        />
      ) : (
        <button
          onClick={() => setShowCreateModal(true)}
          className={"show-modal-btn"}
        >
          +
        </button>
      )}
    </div>
  );
};
export default FilmList;
